import React, { Component } from "react";
import { browserHistory } from "react-router";
import { Button } from "@sketchpixy/rubix";
import { PulseLoader } from "halogen";
import {
  GET_STATIC_PAGE_CONTENT_REQUEST,
  GET_STATIC_PAGE_HEADER_REQUEST
} from "../../actions/actions";
import { connect } from "react-redux";
import StaticPage from "./StaticPage";

const styles = {
  spinner: {
    display: "flex",
    height: "60vh",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  }
};

class NotFoundContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aSyncCall: true,
      isThereContent: false,
      content: null,
      headerItems: null
    };
  }

  // static contextTypes = { router: React.PropTypes.object };

  componentDidMount = () => {
    const { pathname } = this.props.location;

    const contentPromise = new Promise((resolve, reject) => {
      this.props.dispatch({
        type: GET_STATIC_PAGE_CONTENT_REQUEST,
        pathname,
        resolve,
        reject
      });
    });

    const headerItemsPromise = new Promise((resolve, reject) => {
      this.props.dispatch({
        type: GET_STATIC_PAGE_HEADER_REQUEST,
        resolve,
        reject
      });
    });

    Promise.all([contentPromise, headerItemsPromise])
      .then(([pageContent, headerItems]) => {
        this.setState({
          aSyncCall: false,
          isThereContent: true,
          content: pageContent.page,
          headerItems: headerItems.pages
        });
      })
      .catch(() =>
        this.setState({
          aSyncCall: false,
          isThereContent: false
        })
      );
  };

  render() {
    if (this.state.aSyncCall) {
      return (
        <div style={styles.spinner}>
          <PulseLoader color={"#00abde"} />
        </div>
      );
    } else {
      if (this.state.isThereContent) {
        return (
          <StaticPage
            page={this.state.content}
            headerItems={this.state.headerItems}
          />
        );
      } else {
        return (
          <div id="not-found-wrapper">
            <div className="inner-message">
              <h3>چنین صفحه ای یافت نشد</h3>
              <Button
                outlined
                bsStyle="warning"
                onClick={() => browserHistory.push("/")}
              >
                بازگشت به صفحه نخست
              </Button>
            </div>
          </div>
        );
      }
    }
  }
}

export default connect()(NotFoundContainer);



// WEBPACK FOOTER //
// ./src/components/common/NotFoundContainer.js